import { render, staticRenderFns } from "./knowledge.vue?vue&type=template&id=7ec99fe2&scoped=true&"
import script from "./knowledge.vue?vue&type=script&lang=ts&"
export * from "./knowledge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec99fe2",
  null
  
)

export default component.exports